import isEmpty from "lodash-es/isEmpty";
import { Button, DeleteIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  EfsMelcoEfsModelsUserFormatListItem,
  useConfirm,
} from "melco-shared-logic";
import { Key } from "antd/lib/table/interface";
import { useDeleteUsers } from "../../hooks/administration/useDeleteUsers";

type BulkActionDeleteUsersFormatsProps<T> = {
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
  refetch?: () => Promise<any>;
  data?: T[];
};

export const BulkActionDeleteUsers: React.FC<
  BulkActionDeleteUsersFormatsProps<EfsMelcoEfsModelsUserFormatListItem>
> = ({ selectedRowKeys, setSelectedRowKeys, refetch }) => {
  const { t } = useTranslation();

  const deleteUsers = useDeleteUsers();

  const confirmDelete = useConfirm(
    async () => {
      const successfullyDeletedIds = await deleteUsers(
        selectedRowKeys.map((key) => key.toString())
      );

      if (refetch) {
        refetch();
      }

      // keep items that were not deleted selected
      setSelectedRowKeys(
        selectedRowKeys.filter(
          (id) => !successfullyDeletedIds.includes(id.toString())
        )
      );
    },
    {
      translationPrefix: "users.actions.delete",
      translationOptions: {
        count: selectedRowKeys.length,
      },
    }
  );

  if (isEmpty(selectedRowKeys)) {
    return null;
  }

  return (
    <Button
      key="bulk-delete"
      icon={<DeleteIcon />}
      onClick={() => {
        confirmDelete();
      }}
    >
      {t("users.actions.delete.button")}
    </Button>
  );
};
